import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-confirmation',
  standalone: true,
  imports: [],
  templateUrl: './save-confirmation.component.html',
  styleUrl: './save-confirmation.component.css'
})
export class SaveConfirmationComponent {
  
  constructor(private dialogRef: MatDialogRef<SaveConfirmationComponent>) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.dialogRef.close();
    }, 4000); // 4000 milisegundos = 4 segundos
  }
}
